/** Storage can throw (private mode, blocked cookies, quota). Everything must work without it. */
function wrap(get: () => Storage) {
  return {
    get(key: string): string | null {
      try {
        return get().getItem(key);
      } catch {
        return null;
      }
    },
    set(key: string, value: string): boolean {
      try {
        get().setItem(key, value);
        return true;
      } catch {
        return false;
      }
    },
    del(key: string): void {
      try {
        get().removeItem(key);
      } catch {
        /* ignore */
      }
    },
    json<T>(key: string, fallback: T): T {
      try {
        const raw = get().getItem(key);
        return raw ? (JSON.parse(raw) as T) : fallback;
      } catch {
        return fallback;
      }
    },
  };
}

export const local = wrap(() => localStorage);
export const session = wrap(() => sessionStorage);

export const KEYS = {
  favorites: 'mojfair:favs:v1',
  filters: 'mojfair:filters',
  feedState: 'mojfair:feed:state:v1',
  feedSnapshot: 'mojfair:feed:snapshot:v1',
  sid: 'mojfair:sid',
} as const;
